// 查询结果
<template>
  <div class="resultBar ">
    <img src="../assets/image/line.jpg" alt style="width:100%">
    <div class="resultSlotBox">
      <slot name="resultRight"></slot>
    </div>
  </div>
</template>
<script>

export default {
  name: 'resultBar',
  data () {
    return {

    }
  },
  methods: {
  },
  mounted () {

  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/base.scss";
@import "../assets/scss/public.scss";
.resultBar {
  position: relative;
  height: 40px;
  margin-bottom: 10px;
  .resultSlotBox {
    position: absolute;
    height: 24px;
    right: 16px;
    top: calc(50% - 24px / 2);
    /deep/.el-button {
      padding: 0 10px;
      height: 24px;
      line-height: 24px;
      border: 1px solid $colorC;
      color: $colorC;
    }
  }
}
</style>